import { RootState } from '@/store';
import { createSelector } from '@reduxjs/toolkit';
import { LLMConfigState, SLICE_NAME } from './models';

const llmConfigSelector = (state: RootState): LLMConfigState => state[SLICE_NAME];

export const selectLLMConfig = createSelector(llmConfigSelector, (state: LLMConfigState) => state.llmConfig);

export const selectLLMConfigIsLoading = createSelector(llmConfigSelector, (state: LLMConfigState) => state.isLoading);

export const selectLLMConfigError = createSelector(llmConfigSelector, (state: LLMConfigState) => state.error);
